import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { DomSanitizer } from '@angular/platform-browser';
import { DateFnsModule } from 'ngx-date-fns';
import { CalendarDatePickerDialogComponent } from '../calendar-date-picker-dialog/calendar-date-picker-dialog.component';

@Component({
  selector: 'app-calendar-date-picker-field',
  templateUrl: './calendar-date-picker-field.component.html',
  styleUrl: './calendar-date-picker-field.component.css',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    DateFnsModule,
    MatButtonModule,
  ],
})
export class CalendarDatePickerFieldComponent {
  @Input() storeId: number = 0;
  @Input() sendoutId?: number;
  @Input() formGroup!: FormGroup;
  @Input() controlName: string = '';
  @Input() overrideLocks = false;
  @Input() label: string = '';
  @Input() placeholder: string = '';
  readonly dialog = inject(MatDialog);
  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ) {
    this.matIconRegistry.addSvgIcon(
      'calendar',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../../../../assets/calendar.svg'
      )
    );
  }

  get control(): FormControl {
    return this.formGroup.get(this.controlName) as FormControl;
  }

  selectDate() {
    if (this.control.disabled) {
      return;
    }
    const dialogRef = this.dialog.open(CalendarDatePickerDialogComponent, {
      width: '90%',
      maxWidth: '100vw',

      data: {
        storeId: this.storeId,
        sendoutId: this.sendoutId,
        selectedDate: this.control.value,
      },
    });
    dialogRef
      .afterClosed()
      .subscribe(async (result: { confirmed: boolean; date: Date }) => {
        this.control.markAsTouched();
        if (result && result.confirmed && result.date) {
          this.control.patchValue(result.date);
          this.control.markAsDirty();
        }
      });
  }
}
